// Dual-path event firing: browser Pixel + server-side Conversions API,
// sharing the same event_id so Meta deduplicates.
// AEPD/RGPD: every path is gated on the user's advertising consent —
// nothing reaches Meta (or our /api/capi/* relay) until the user opts in
// from the AEPD cookie banner.
import { apiClient } from "./api";
import {
  trackFbEvent,
  buildAttributionPayload,
  generateEventId,
} from "./fbpixel";
import { hasAdConsent } from "./consent";

/**
 * Fire PageView on both channels.
 * Safe to call multiple times per session; the caller decides frequency.
 * No-op (returns null) when the user has not granted advertising consent.
 */
export async function firePageView() {
  if (!hasAdConsent()) return null;
  const eventId = generateEventId();
  // Browser first — cheap and sync
  trackFbEvent("PageView", {}, eventId);
  // Server-side (fire-and-forget). Any failure is swallowed by the backend.
  try {
    await apiClient.post("/capi/pageview", {
      event_id: eventId,
      ...buildAttributionPayload(),
    });
  } catch (_) {
    // never break the page on CAPI relay errors
  }
  return eventId;
}

/**
 * Fire ViewContent on both channels. Meant to be triggered once per session
 * when the registration form becomes visible.
 * No-op when the user has not granted advertising consent.
 */
export async function fireViewContent() {
  if (!hasAdConsent()) return null;
  const eventId = generateEventId();
  trackFbEvent(
    "ViewContent",
    {
      content_name: "Masterclass en directo — Tu segundo acto",
      content_category: "masterclass_registration_form",
    },
    eventId
  );
  try {
    await apiClient.post("/capi/view-content", {
      event_id: eventId,
      ...buildAttributionPayload(),
    });
  } catch (_) {
    /* swallow */
  }
  return eventId;
}
